export default "__VITE_ASSET__f1ca02b4__"